import { render, staticRenderFns } from "./query-pivot.vue?vue&type=template&id=42f53a8c&scoped=true&"
import script from "./query-pivot.vue?vue&type=script&lang=js&"
export * from "./query-pivot.vue?vue&type=script&lang=js&"
import style0 from "./query-pivot.vue?vue&type=style&index=0&id=42f53a8c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42f53a8c",
  null
  
)

export default component.exports